if (!customElements.get('product-reels')) {
  customElements.define(
    'product-reels',
    class ProductReels extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.product-reels__card')).filter((card) =>
          card.querySelector('video')
        );
        if (!this.cards.length) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reducedMotion;

        this.cards.forEach((card) => {
          const video = card.querySelector('video');
          video.muted = true;
          video.addEventListener('playing', () => card.classList.add('is-playing'));
          video.addEventListener('pause', () => card.classList.remove('is-playing'));

          const sound = card.querySelector('[data-sound]');
          if (sound) {
            sound.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.toggleSound(card);
            });
          }

          if (!this.autoplay) {
            card.addEventListener('mouseenter', () => this.play(video));
            card.addEventListener('mouseleave', () => video.pause());
          }
        });

        if (this.autoplay) {
          // Play only the reels that are on screen, to save data and battery.
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target.querySelector('video');
                if (entry.isIntersecting) this.play(video);
                else video.pause();
              });
            },
            { threshold: 0.6 }
          );
          this.cards.forEach((card) => this.observer.observe(card));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      play(video) {
        if (video.preload === 'none') video.preload = 'auto';
        const attempt = video.play();
        if (attempt) attempt.catch(() => {});
      }

      toggleSound(card) {
        const video = card.querySelector('video');
        const sound = card.querySelector('[data-sound]');
        const unmute = video.muted;

        // Only one reel plays sound at a time.
        this.cards.forEach((other) => {
          other.querySelector('video').muted = true;
          other.querySelector('[data-sound]')?.setAttribute('aria-pressed', 'false');
        });

        if (unmute) {
          video.muted = false;
          sound.setAttribute('aria-pressed', 'true');
          this.play(video);
        }
      }
    }
  );
}
